import React, { useCallback } from 'react'
import { NavLink } from 'react-router-dom'
import classNames from 'classnames'

import styles from './TabBar.module.css'

export default function TabBar({ tabs, dark, exact }) {
  return (
    <div className={classNames(styles.wrapper, dark && styles.dark)}>
      {tabs.map(tab => (
        <NavLink
          exact={exact}
          key={tab.to}
          className={styles.item}
          activeClassName={styles.active}
          to={tab.to}
        >
          {tab.name}
        </NavLink>
      ))}
    </div>
  )
}

export const StateTabBar = function StateTabBar({
  tabs,
  onChangeTab,
  activeTab,
  dark,
}) {
  return (
    <div className={classNames(styles.wrapper, dark && styles.dark)}>
      {tabs.map(tab => (
        <StateTab
          tab={tab}
          onChangeTab={onChangeTab}
          active={tab.key === activeTab}
        />
      ))}
    </div>
  )
}

export const StateTab = function StateTab({ tab, onChangeTab, active }) {
  const handleClick = useCallback(() => {
    onChangeTab(tab.key)
  }, [tab, onChangeTab])

  return (
    <a
      className={classNames(styles.item, active && styles.active)}
      onClick={handleClick}
    >
      {tab.name}
    </a>
  )
}
